import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import CitationCell from '@Components/Results/substances/tables/cells/citation-cell.component';
import TargetCell from '@Components/Results/substances/tables/cells/target-cell.component';
import NumberFormatter from '@Utils/NumberFormatter';
import { CITATION_LINKS_TRACKING_INDEX_MARKER } from '@Components/Results/analytics/citationLinksTracking';

function renderBasicDataRow(title, data) {
  return (
    data && (
      <tr>
        <th>{title}</th>
        <InnerHTML tag="td" html={data} />
      </tr>
    )
  );
}

function renderMeasurementsDataRow(title, data) {
  const measurements = [];
  if (data && data.length) {
    data.forEach((measurement) => {
      if (measurement.obj) {
        measurements.push(measurement.obj);
      }
    });
  }
  return measurements.length ? (
    <tr>
      <th>{title}</th>
      <InnerHTML tag="td" html={measurements.join(', ')} />
    </tr>
  ) : null;
}

function SubstanceQualitativeTable({ metadata, data, total }) {
  return (
    <div className="qualitative-information">
      {map(data, (item, index) => (
        <div key={index} className="qualitative-information__item">
          <div className="qualitative-information__count">
            {NumberFormatter(index + 1, 0)} of {NumberFormatter(total, 0)}
          </div>

          <table className="rx-table rx-table--full-width qualitative-information__table">
            <tbody>
              {renderBasicDataRow('Effect', item.details.effect)}
              {item.details.targets && (
                <tr>
                  <th>Target</th>
                  <td>
                    <TargetCell metadata={metadata} value={item.details.targets} />
                  </td>
                </tr>
              )}
              {renderBasicDataRow('Substance action on target', item.details.targetAction)}
              {(item.details.bioSpecies || item.details.tissueOrgan || item.details.cell) && (
                <tr>
                  <th>Biological material</th>
                  <td>
                    {item.details.bioSpecies && <div>{item.details.bioSpecies.join(' + ')}</div>}
                    {item.details.tissueOrgan && <div>{item.details.tissueOrgan.join(' + ')}</div>}
                    {item.details.cell && <div>{item.details.cell.join(' + ')}</div>}
                  </td>
                </tr>
              )}
              {renderBasicDataRow('Assay Description', item.details.assayDescription)}
              {renderBasicDataRow('Results', item.details.results)}
              {item.details.citations && (
                <tr {...CITATION_LINKS_TRACKING_INDEX_MARKER.substancesTableItem}>
                  <th>Reference</th>
                  <td>
                    <CitationCell metadata={metadata} citations={item.details.citations} />
                  </td>
                </tr>
              )}
              {renderMeasurementsDataRow('Measurement', item.measurements)}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

SubstanceQualitativeTable.propTypes = {
  metadata: MetadataPropTypesShape,
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
};

export default SubstanceQualitativeTable;
